/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
import { Directive, TemplateRef, ViewContainerRef } from '@angular/core';
import { TemplatePortalDirective } from '@angular/cdk/portal';
/**
 * Workaround for https://github.com/angular/angular/issues/17849
 */
export const _MatTabLabelBaseClass = TemplatePortalDirective;
/**
 * Used to flag tab labels for use with the portal directive
 */
export class MatTabLabel extends _MatTabLabelBaseClass {
    /**
     * @param {?} templateRef
     * @param {?} viewContainerRef
     */
    constructor(templateRef, viewContainerRef) {
        super(templateRef, viewContainerRef);
    }
}
MatTabLabel.decorators = [
    { type: Directive, args: [{
                selector: '[mat-tab-label], [matTabLabel]',
            },] },
];
/**
 * @nocollapse
 */
MatTabLabel.ctorParameters = () => [
    { type: TemplateRef, },
    { type: ViewContainerRef, },
];
function MatTabLabel_tsickle_Closure_declarations() {
    /** @type {?} */
    MatTabLabel.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    MatTabLabel.ctorParameters;
}
//# sourceMappingURL=tab-label.js.map